import {ErrorHandler, Injectable, Injector} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {LoggingService} from './logging.service';
import {FabMessageService} from '@fabric/components/message';
@Injectable({
  providedIn: 'root'
})
export class FeaasErrorHandlerService implements ErrorHandler{

  constructor(
    private fabMessageService: FabMessageService,
    private injector: Injector) {
  }

  public handleError(error: any): void {
    const loggingService =  this.injector.get(LoggingService);
    let message: string;
    let stackTrace: string;
    if (error instanceof HttpErrorResponse) {
      // Server error
      message = this.getServerErrorMessage(error);
      stackTrace = error.message;
      this.fabMessageService.displayError(message, 'Okay');
    } else {
      message = this.getClientErrorMessage(error);
      stackTrace = error.stack ? error.stack : '';
      this.fabMessageService.displayError(message, 'Okay');
    }
    // log errors
    loggingService.logError(message, stackTrace);
  }
  private getClientErrorMessage(error: Error): string {
    return error.message ? error.message : error.toString();
  }
  private getServerErrorMessage(error: HttpErrorResponse): string {
    return navigator.onLine ? `Error Code ${error.status}: ${error.message}` : 'No Connection';
  }
}
